<template>
  <v-row
    v-if="requests.length()>0"
    justify=center
    class="main--text">
    <v-col
      md=7
      sm=10>
      <v-card
        v-if="!isLoading"
        >
        <v-container
          fluid>
          <v-row
            align=center
            no-gutters>
            <v-col>
              <h3>{{student.fullName()}}さん 宛に{{ teachers.length() }}件のリクエストがあります</h3>
            </v-col>
          </v-row>
        </v-container>
        <v-container
          v-for="(request, index) in requests.get()"
          :key="request.id"
          fluid
          class="no--vertical--paddings">
          <v-request-from-teacher
            :request="request"
            @info-button-click="info"
            @accept-button-click="accept"
            @deny-button-click="deny"/>
          <v-divider v-if="teachers.length() > index + 1"></v-divider>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { firestore } from "@/repository/client/firestore"
import { TeacherRepository } from "@/repository/TeacherRepository"
import VRequestFromTeacher from '@/components/organisms/parent/VRequestFromTeacher'

export default {
  components: {
    VRequestFromTeacher
  },
  props:{
    student: Object,
    requests: Object
  },
  data () {
    return {
      teachers: null,
      teacherRepo: null,
      isLoading: true
    }
  },
  methods: {
    async accept(teacher) {
      const request = this.requests.findBySenderId(teacher.getId())
      this.$emit("accept-button-click", request)
      // this.teachers.remove(teacher)
    },
    async deny(teacher) {
      const request = this.requests.findBySenderId(teacher.getId())
      this.$emit("deny-button-click", request)
      this.teachers.remove(teacher)
    },
    info(teacher) {
      this.$emit("info-button-click", teacher)
    }
  },
  created: async function () {
    this.teacherRepo = new TeacherRepository(firestore)
    this.teachers = await this.teacherRepo.collect(this.requests.senderIds())
    this.isLoading = false
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
